"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _theme = require("../../../../../../../theme");
var useStyles = (0, _theme.makeStyles)(function (_ref) {
  var _ref$palette = _ref.palette,
    primary = _ref$palette.primary,
    text = _ref$palette.text,
    shade = _ref.utils.shade;
  return {
    root: {
      marginBottom: 8,
      cursor: 'pointer',
      padding: '8px 16px',
      borderBottom: "1px solid ".concat(shade(text.primary, 2))
    },
    selected: {
      color: primary.main
    }
  };
}, {
  name: 'StaticRangeButton'
});
exports.useStyles = useStyles;